import React, { Component, Fragment } from 'react'
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import 'react-phone-input-2/lib/bootstrap.css';
import PhoneInput from 'react-phone-input-2';

import validation from '../../validation/validation';
import axios from 'axios'
import AppURL from '../../api/AppURL';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export class RequestForQuote extends Component {

    componentDidMount() {
        window.scroll(0, 0)
    }

    constructor() {
        super();
        this.state = {
            name: "",
            email: "",
            contact: "",
            location: "",
            subject: "",
            message: "",
        }
    }

    nameOnChange = (event) => {
        let name = event.target.value;
        this.setState({ name: name })
    }

    emailOnChange = (event) => {
        let email = event.target.value;
        this.setState({ email: email })
    }

    contactOnChange = (phone) => {
        this.setState({ contact: phone })
    }

    locationOnChange = (event) => {
        let location = event.target.value;
        this.setState({ location: location })
    }

    subjectOnChange = (event) => {
        let subject = event.target.value;
        this.setState({ subject: subject })
    }

    messageOnChange = (event) => {
        let message = event.target.value;
        this.setState({ message: message })
    }

    onFormSubmit = (event) => {

        event.preventDefault();

        let name = this.state.name;
        let email = this.state.email;
        let contact = this.state.contact;
        let location = this.state.location;
        let subject = this.state.subject;
        let message = this.state.message;

        let sendBtn = document.getElementById('sendBtn');
        let requestForm = document.getElementById('requestForm');

        if (name.length === 0) {
            toast.error("Please write your name");
        }

        else if (email.length === 0) {
            toast.error("Please write your Email");
        }

        else if (contact.length === 0) {
            toast.error("Please write your Contact");
        }

        else if (location.length === 0) {
            toast.error("Please write your location");
        }

        else if (subject.length === 0) {
            toast.error("Please write your subject");
        }

        else if (message.length === 0) {
            toast.error("Please write your message");
        }

        else if (!(validation.NameRegx).test(name)) {
            toast.error("Invalid Name");
        }

        else {

            sendBtn.innerHTML = "Sending...";

            let MyFormData = new FormData();

            MyFormData.append("name", name)
            MyFormData.append("email", email)
            MyFormData.append("contact", contact)
            MyFormData.append("location", location)
            MyFormData.append("subject", subject)
            MyFormData.append("message", message)

            axios.post(AppURL.PostQuote, MyFormData)

                .then(function (response) {

                    if (response.status === 200 && response.data) {

                        toast.success("Request sent successfully");

                        sendBtn.innerHTML = "Send Request";

                    requestForm.reset();

                        this.setState({
                            name: "",
                            email: "",
                            contact: "",
                            location: "",
                            subject: "",
                            message: ""
                        });




                    }

                    else {

                        toast.error("Something went wrong");

                        sendBtn.innerHTML = "Send Request";

                    }

                })

                .catch(function (error) {

                    toast.error("Server Error");

                    sendBtn.innerHTML = "Send Request";

                });

        }

    }

    render() {

        return (

            <Fragment>

                <div className="bg-light py-5">

                    <Container>

                        <h2 className="text-center mb-4">
                            <strong>Request for Quote</strong>
                        </h2>

                        <Row className="g-4">

                            {/* LEFT SIDE */}

                            <Col lg={6} md={12}>

                                <Card className="h-100 shadow-sm">

                                    <Card.Body>

                                        <h4 className="mb-3">
                                            Why Choose Us at ChrisAlpha Tech Company Ltd
                                        </h4>

                                        <p>
                                            We provide reliable and professional IT solutions
                                            to help businesses grow and operate efficiently.
                                        </p>

                                        <ul>
                                            <li>✔ Professional and experienced team</li>
                                            <li>✔ Reliable software solutions</li>
                                            <li>✔ Fast customer support</li>
                                            <li>✔ Affordable pricing</li>
                                            <li>✔ Secure and modern technology</li>
                                            <li>✔ Trusted by many businesses</li>
                                        </ul>

                                        <p>
                                            At ChrisAlpha Tech Company Ltd, we are committed
                                            to delivering high-quality services including
                                            software development, website development,
                                            networking, CCTV installation, and business
                                            automation solutions.
                                        </p>

                                    </Card.Body>

                                </Card>

                            </Col>

                            {/* RIGHT SIDE FORM */}

                            <Col lg={6} md={12}>

                                <Card className="shadow-sm">

                                    <Card.Body>

                                        <h4 className="mb-3">
                                            Request a Quote
                                        </h4>

                                        <Form
                                            id="requestForm"
                                            onSubmit={this.onFormSubmit}
                                        >

                                            {/* NAME & EMAIL */}

                                            <Row>

                                                <Col md={6}>

                                                    <input
                                                        onChange={this.nameOnChange}
                                                        className="form-control mb-3"
                                                        type="text"
                                                        placeholder="Enter Your Full Name"
                                                    />

                                                </Col>

                                                <Col md={6}>

                                                    <input
                                                        onChange={this.emailOnChange}
                                                        className="form-control mb-3"
                                                        type="email"
                                                        placeholder="Enter Your Email"
                                                    />

                                                </Col>

                                            </Row>

                                            {/* PHONE & LOCATION */}

                                            <Row>

                                                <Col md={6}>

                                                    <Form.Group className="mb-3">

                                                        <Form.Label>
                                                            Contact Number
                                                        </Form.Label>

                                                        <PhoneInput
                                                            onChange={this.contactOnChange}
                                                            country={"ug"}
                                                            enableSearch={true}
                                                            containerStyle={{
                                                                width: "100%"
                                                            }}
                                                            inputStyle={{
                                                                width: "100%",
                                                                height: "38px",
                                                                fontSize: "14px"
                                                            }}
                                                            buttonStyle={{
                                                                height: "38px"
                                                            }}
                                                        />

                                                    </Form.Group>

                                                </Col>

                                                <Col md={6}>

                                                    <input
                                                        onChange={this.locationOnChange}
                                                        className="form-control mb-3"
                                                        type="text"
                                                        placeholder="Enter Your Location"
                                                    />

                                                </Col>

                                            </Row>

                                            {/* SUBJECT */}

                                            <input
                                                onChange={this.subjectOnChange}
                                                className="form-control mb-3"
                                                type="text"
                                                placeholder="Enter Subject"
                                            />

                                            {/* MESSAGE */}

                                            <Form.Control
                                                onChange={this.messageOnChange}
                                                className="form-control mb-3"
                                                as="textarea"
                                                rows={3}
                                                placeholder="Message"
                                            />

                                            {/* BUTTON */}

                                            <div className="d-grid">

                                                <Button
                                                    id="sendBtn"
                                                    type="submit"
                                                    className="btn btn-primary"
                                                >
                                                    Send Request
                                                </Button>

                                            </div>

                                        </Form>

                                    </Card.Body>

                                </Card>

                            </Col>

                        </Row>

                    </Container>

                </div>

                <ToastContainer />

            </Fragment>

        )

    }

}

export default RequestForQuote;